export const ADMIN_ROLES = {
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  BILLING: 'BILLING',
};
